<m-input-group
    class="m-radio-group"
    :class="{
        'm--is-inline': inline,
        'm--is-disabled': isDisabled,
        'm--has-error': hasError,
        'm--is-valid': isValid,
        'm--has-validation-message': hasValidationMessage
    }"
    :label="label"
    :required-marker="requiredMarker"
    :validation-message-id="validationMessageId"
    :disabled="isDisabled"
    :waiting="isWaiting"
    :error="hasError"
    :error-message="errorMessage"
    :valid="isValid"
    :valid-message="validMessage"
    :helper-message="helperMessage"
    :validationMessagePosition="validationMessagePosition"
    @focusin="onFocus"
    @focusout="onBlur"
>
    <slot name="icon" slot="icon" />

    <ul class="m-radio-group__body"
        role="radiogroup">
        <slot />
    </ul>
</m-input-group>
